// extracted by mini-css-extract-plugin
export var committeeWrapper = "volunteers-module--committee-wrapper--LDQ0H";
export var volunteersWrapper = "volunteers-module--volunteers-wrapper--aenvw";